import { DateTime } from 'luxon';

export const toISO8601 = (date: Date): string => {
  return DateTime.fromJSDate(date).toISODate() || '';
};

export const fromISO8601 = (date: string): Date => {
  return DateTime.fromISO(date).toJSDate();
};
